import React, { useState } from "react";
import data from "./data";

const Tabs = () => {
  const [dataSaiRoom, satDataSaiRoom] = useState(data[0]);
  const t_room = dataSaiRoom.tabs[0];
  return (
    <div className="">
      <ul
        className="nav nav-pills mb-3 flex flex-nowrap justify-between max-sm:justify-center bg-gray-500 text-gray-900 rounded"
        id="pills-tab"
        role="tablist"
      >
        <li className="nav-item w-50" role="presentation">
          <button
            className="nav-link text-xl active lg:px-10 md:px-5 sm:px-2 py-3 w-full"
            id="ac-tab"
            data-bs-toggle="pill"
            data-bs-target="#ac"
            type="button"
            role="tab"
            aria-controls="ac"
            aria-selected="false"
          >
            Ac
          </button>
        </li>
        <li className="nav-item w-50" role="presentation">
          <button
            className="nav-link text-xl md:px-10 sm:px-2 py-3 w-full"
            id="non-ac-tab"
            data-bs-toggle="pill"
            data-bs-target="#non-ac"
            type="button"
            role="tab"
            aria-controls="non-ac"
            aria-selected="false"
          >
            Non-Ac
          </button>
        </li>
      </ul>
      <div className="tab-content" id="pills-tabContent">
        
        <div
          className="tab-pane fade show active"
          id="ac"
          role="tabpanel"
          aria-labelledby="ac-tab"
          tabIndex="0"
        >
          <h1 className="text-heading font-bold pb-5">
            A.C. Rooms Available For Online Booking & Local Booking
          </h1>
          <div className=" overflow-x-scroll ">
            <table className="table  table-responsive w-100">
              <thead>
                <tr>
                  <th>Room No</th>
                  <th>Room Type</th>
                  <th>Room Rent</th>
                  <th>Min Cap</th>
                  <th>Max Cap</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {t_room.ac.map((acroom) => {
                  return (
                    <tr key={acroom.id}>
                      <td>{acroom.sr_n}</td>
                      <td>{acroom.r_type}</td>
                      <td>{acroom.r_desc}</td>
                      <td>{acroom.min_cap}</td>
                      <td>{acroom.max_cap}</td>
                      <td>{acroom.rate}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="non-ac"
          role="tabpanel"
          aria-labelledby="non-ac-tab"
          tabIndex="0"
        >
          <h1 className="text-heading font-bold pb-5">
            Non A.C. Rooms Available For Online Booking & Local Booking
          </h1>
          <div className=" overflow-x-scroll ">
            <table className="table  table-responsive w-100">
              <thead>
                <tr>
                  <th>Room No</th>
                  <th>Room Type</th>
                  <th>Room Rent</th>
                  <th>Min Cap</th>
                  <th>Max Cap</th>
                  <th>Price</th>
                </tr>
              </thead>
              <tbody>
                {t_room.n_ac.map((n_acroom) => {
                  return (
                    <tr key={n_acroom.id}>
                      <td>{n_acroom.sr_n}</td>
                      <td>{n_acroom.r_type}</td>
                      <td>{n_acroom.r_desc}</td>
                      <td>{n_acroom.min_cap}</td>
                      <td>{n_acroom.max_cap}</td>
                      <td>{n_acroom.rate}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
